import React from 'react';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import Contact from './Contact';
import ScrollToTop from "react-scroll-to-top";
const ContactPage = () => {
    return (
        <>
            <ScrollToTop smooth />
            <Navbar />
            <Contact />
            <Footer />
        </>
    );
};

export default ContactPage;